import NextToPlay from './NextToPlay.vue';
import NextToPlaySquare from './NextToPlaySquare.vue';
import NextToPlayWide from './NextToPlayWide.vue';
import state from './state/NextToPlay';

// We are intentionally exposing components that *may* be required by the bundle-consumer
// Source-code-consumers like odds.com.au can directly import modules, so are not affected
export default { NextToPlay, NextToPlaySquare, NextToPlayWide, state };
